"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COSMOS_ADDRESS_PREFIX = {
    cosmoshub: 'cosmos',
    irishub: 'iaa',
    kava: 'kava',
    columbus: 'terra',
};
